import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

// Import bill components (lazy-loaded for performance)
const Bills = React.lazy(() => import("./Bills"));
const NewBill = React.lazy(() => import("./NewBill"));
const BillDetails = React.lazy(() => import("./BillDetails"));
const BillPDFPreview = React.lazy(() => import("./BillPDFPreview"));
const PaymentReceivingDetails = React.lazy(() => import("./PaymentReceivingDetails"));
const EditPaymentDetails = React.lazy(() => import("./EditPaymentDetails"));
const BillingDetails = React.lazy(() => import("./BillingDetails"));

const billsModuleConfig: ModuleConfig = {
    // 🏷️ MODULE IDENTITY
    id: "bills",
    name: "Simple Bills",
    description: "Create, send, and track invoices and bills",
    version: "1.1.0",
    enabled: true,
    category: "billing",
    order: 6,
    icon: "💳",
    color: "#E53E3E",

    // 🛣️ ROUTES
    routes: [
        {
            path: "/bills",
            component: Bills,
            permissions: ["ADMIN", "MANAGER"]
        },
        {
            path: "/bills/new",
            component: NewBill,
            permissions: ["ADMIN", "MANAGER"]
        },
        {
            path: "/bills/payment-details",
            component: PaymentReceivingDetails,
            permissions: ["USER", "ADMIN", "MANAGER"]
        },
        {
            path: "/bills/payment-details/edit",
            component: EditPaymentDetails,
            permissions: ["USER", "ADMIN", "MANAGER"]
        },
        {
            path: "/bills/billing-details",
            component: BillingDetails,
            permissions: ["USER", "ADMIN", "MANAGER"]
        },
        {
            path: "/bill/:id",
            component: BillDetails,
            permissions: ["ADMIN", "MANAGER"]
        },
        {
            path: "/bill/:id/preview",
            component: BillPDFPreview,
            permissions: ["USER", "ADMIN", "MANAGER"]
        }
    ],

    // 🧭 NAVIGATION
    navigation: [
        {
            label: "All Bills",
            path: "/bills",
            icon: "📄",
            permissions: ["ADMIN", "MANAGER"]
        },
        {
            label: "New Bill",
            path: "/bills/new",
            icon: "➕",
            permissions: ["ADMIN", "MANAGER"]
        },
        {
            label: "Payment Details",
            path: "/bills/payment-details",
            icon: "💳",
            permissions: ["USER", "ADMIN", "MANAGER"]
        },
        {
            label: "Billing Details",
            path: "/bills/billing-details",
            icon: "📋",
            permissions: ["USER", "ADMIN", "MANAGER"]
        }
    ],

    // 🔐 PERMISSIONS
    permissions: {
        view: ["USER", "ADMIN", "MANAGER"],
        create: ["ADMIN", "MANAGER"],
        edit: ["ADMIN", "MANAGER"],
        delete: ["ADMIN"]
    },

    // ⚡ QUICK ACTIONS
    quickActions: [
        {
            label: "Create Bill",
            path: "/bills/new",
            icon: "➕",
            description: "Create a new invoice or bill"
        }
    ]
};

export default billsModuleConfig;